export const loadingMessage = 'Cargando...';
